import React, { lazy } from "react";
import Loadable from "components/Loadable";
import { commonRoutesConstants, routeConstants } from "services/keyConstants";
import CommonYearList from "components/reusables/CommonYearList";
import * as url from "./urlHelper";

// Define lazy-loaded components

const ProductRecallRegister = Loadable(
  lazy(() => import("../ProductRecallRegister"))
);
const RetunedGoodsRecords = Loadable(
  lazy(() => import("../RetunedGoodsRecords"))
);
const AdvisoryNotice = Loadable(lazy(() => import("../AdvisoryNotice")));

const AdvisoryNoticeList = Loadable(
  lazy(() => import("../AdvisoryNoticeList"))
);

const YearWiseDocument = Loadable(lazy(() => import("../YearWiseDocument")));

// Define routes using lazy-loaded components
const ARRoutes = [
  {
    path: routeConstants.ADVISORY_NOTICE_AND_RECALL,
    children: [
      {
        path: "product-recall-register/:id",
        element: <ProductRecallRegister />,
      },
      { path: "returned-goods-record", element: <RetunedGoodsRecords /> },
      { path: "advisory-notice", element: <AdvisoryNotice /> },
      { path: "advisory-list/:year", element: <AdvisoryNoticeList /> },
      {
        path: commonRoutesConstants.YEAR_LIST,
        element: (
          <CommonYearList
            uri={url.GET_BY_YEAR}
            title="Advisory Notice & Recall"
            navigateToFolder={`/${routeConstants.ADVISORY_NOTICE_AND_RECALL}/list/`}
          />
        ),
      },
      {
        path: "year-wise-document/:documentName",
        element: <YearWiseDocument />,
      },
    ],
  },
];

export default ARRoutes;
